import React,{useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import '../css/CompanyHouseDetails.css'

export default function MobileCompanyHeader () {
    const companyName = useSelector(state => state.chouse.companyName);
    const companyNumber = useSelector(state => state.chouse.companyNumber);
    const updatedat = useSelector(state => state.chouse.updatedat)
    const lead = useSelector(state => state.data.rowdata)

    if(lead && companyNumber && typeof companyNumber !== 'undefined')
        return (
            <div>
                <h1>{companyName}</h1>
                <p className="company-number">
                Company number&nbsp;<span className='boldtext'>{companyNumber}</span><br/>
                Main Contact: {lead["FullName"]}<br/>
                <span className='updatedat'>Updated from Company House API at {new Date(updatedat??new Date()).toLocaleString()}</span><br/>
                </p>
            </div>
        )
}